import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RegisterModal from "./RegisterModal";

const links = {
  "/": "Home",
  "/testing": "Integration Testing",
  "/device": "Device Config",
  "/debug": "Debug",
  "/inventory": "Inventory",
  "/devicetesting": "Testing Device",
  "/ota-update": "OTA Update",
  "/water-quality-parameters": "Water Quality",
  "/pcb-testing": "PCB Testing",
};

export default function Navbar() {
  const [showRegister, setShowRegister] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  function gotoRoute(route) {
    // if (isTesting) {
    //   toast.error("Please stop testing before changing routes");
    //   return;
    // }
    navigate(route);
  }

  return (
    <div className="flex fixed top-0 z-50 gap-10 justify-center py-5 px-5 w-full text-xl bg-white shadow">
      {Object.keys(links).map((link) => (
        <button
          key={link}
          to={link}
          className={`${location.pathname === link ? "text-indigo-500 font-bold" : ""}`}
          onClick={() => gotoRoute(link)}
        >
          {links[link]}
        </button>
      ))}
      <div className="relative">
        <button
          className="text-indigo-500 font-bold border px-3 py-1 rounded hover:bg-indigo-50"
          onClick={() => setShowRegister(true)}
        >
          Register
        </button>
        <RegisterModal open={showRegister} onClose={() => setShowRegister(false)} />
      </div>
    </div>
  );
}
